import { Component } from '@angular/core';

import { IconBase } from './icon-base';
@Component({
  selector: 'moon-outline',
  imports: [],
  template: `
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.4599 22.7501C12.2899 22.7501 12.1199 22.7501 11.9499 22.7401C6.34995 22.4901 1.66995 17.9801 1.27995 12.4801C0.939948 7.76011 3.66995 3.35011 8.06995 1.50011C9.31995 0.980114 9.97995 1.38011 10.2599 1.67011C10.5399 1.95011 10.9299 2.60011 10.4099 3.79011C9.94995 4.85011 9.71995 5.98011 9.72995 7.14011C9.74995 11.5701 13.4299 15.3301 17.9199 15.5101C18.5699 15.5401 19.2099 15.4901 19.8299 15.3801C21.1499 15.1401 21.6999 15.6701 21.9099 16.0101C22.1199 16.3501 22.3599 17.0801 21.5599 18.1601C19.4399 21.0601 16.0699 22.7501 12.4599 22.7501ZM2.76995 12.3701C3.10995 17.1301 7.16995 21.0301 12.0099 21.2401C15.2999 21.4001 18.4199 19.9001 20.3399 17.2801C20.4899 17.0701 20.5599 16.9201 20.5899 16.8401C20.4999 16.8301 20.3399 16.8201 20.0899 16.8701C19.3599 17.0001 18.5999 17.0501 17.8499 17.0201C12.5699 16.8101 8.24995 12.3801 8.21995 7.16011C8.21995 5.78011 8.48995 4.45011 9.03995 3.20011C9.13995 2.98011 9.15995 2.83011 9.16995 2.75011C9.07995 2.75011 8.91995 2.77011 8.65995 2.88011C4.84995 4.48011 2.48995 8.30011 2.76995 12.3701Z" />
    </svg>
  `,
  styles: ``,
})
export class MoonOutline extends IconBase {}
